import React, {useState, useEffect} from 'react'
import {
     Grid,
     TextField, 
     Button,
     Box,
     FormHelperText,
     Autocomplete,
     FormControl
} from '@mui/material'
import { useStateValue } from "../../../../context/store";
import {styles} from './styles';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SearchUsers = (props) => {


    const classes = styles()
    const [{organization}, dispatch] = useStateValue();
    const [valuesForm, setValuesForm] = useState({
        regionalName: null,
        positionName: null,
    })


  
    const schema = yup.object().shape({

        idKeyword: yup
        .string()
        .max(16, 'Ingrese máximo 16 caracteres'),
        nameKeyword: yup
        .string()
        .max(80, 'Ingrese máximo 80 caracteres'),
        positionName: yup
        .string(),
        regionalName:   yup
        .string()
        
      });
    
      
      const { register, handleSubmit, setValue, clearErrors, watch, formState:{errors} } = useForm({
        resolver: yupResolver(schema),
        mode: "all",
        reValidateMode: "onChange",
      });
      
      const onSubmit = (data) => {
        if(
            data?.idKeyword !== '' ||
            data.nameKeyword !== '' ||
            data?.positionName !== '' ||
            data?.regionalName !== ''
        ){
            dispatch({
                type: "SET_FILTER_ORGANIZATION_CHART",
                filter: {
                    nameKeyword: data?.nameKeyword,
                    idKeyword: data?.idKeyword,
                    positionName: data?.positionName,
                    regionalName: data?.regionalName,
                    page: 0,
                    size: 10
                  },
                  isFilter: true,
            })
        } else {
            dispatch({
                type: "SET_FILTER_ORGANIZATION_CHART",
                filter: {
                    nameKeyword: null,
                    idKeyword: null,
                    positionName: null,
                    regionalName: null,
                  },
                  isFilter: true,
            })
        }
      }

      const clear = () => {
        setValue('idKeyword', '')
        setValue('nameKeyword', '')
        setValue('position', '')
        setValue('area', '')
        setValue('regionalName', "")
        setValue('positionName', "")
        clearErrors('idKeyword')
        clearErrors('nameKeyword')
        setValuesForm({...valuesForm, regionalName: null, nameKeyword: '' , positionName: null, area: '', regional: ''})
      }

      useEffect(() => {
        clear()
      }, [props?.clearFielForm])

      
      const clearForm = () => {
        if(!validate){
            return null
        }else {
            clear()
        dispatch({
            type: "SET_FILTER_ORGANIZATION_CHART",
            filter: {
                nameKeyword: null,
                idKeyword: null,
                positionName: null,
                regionalName: null,
              },
              isFilter: true,
        })
            props.dataFilter()
        }
        
        }
        

        const validate = (watch('nameKeyword') || watch('idKeyword')  || watch('regionalName') || watch('positionName') || watch('regional') )&& organization?.leaderId

    return (
         <form onSubmit={handleSubmit(onSubmit)} style={{marginTop: '2%'}}>
            <Grid container  spacing={2}>
                <Grid item lg={2.5}>
                    <FormControl variant='outlined' fullWidth size="small">
                        <Autocomplete
                            {...register('regionalName')}
                            options={props?.regionals}
                            autoHighlight
                            // disableClearable
                            noOptionsText="No hay opciones"
                            disabled={!organization?.leaderId}
                            className={classes.dropdown}
                            size="small"
                            closeText='Cerrar'
                            
                            openText='Abrir'
                            clearText='Borrar'
                            getOptionLabel={(option) => option.name}
                            onChange={(e, newValue) => {
                                setValue('regionalName', newValue);
                                setValuesForm({...valuesForm, regionalName: newValue})
                            
                            }}
                            value={valuesForm?.regionalName}
                            renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                    {option.name}
                            </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                disabled={!organization?.leaderId}
                                {...register('regionalName')}
                                label="Programa"
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                placeholder="Programa"
                                />
                            )}
                            
                        />
                    </FormControl>
                </Grid>
                <Grid item lg={2.5}>
                    <FormControl variant='outlined' fullWidth size="small">
                        <Autocomplete
                            {...register('positionName')}
                            id="country-select-demo"
                            options={props?.positions}
                            autoHighlight
                            className={classes.dropdown}
                            size="small"
                            clearText='Borrar'
                            closeText='Cerrar'
                            openText='Abrir'
                            noOptionsText="No hay opciones"
                            disabled={!organization?.leaderId}
                            // disableClearable
                            getOptionLabel={(option) => option?.name }
                            onChange={(e, newValue) => {
                                setValue('positionName', newValue);
                                setValuesForm({...valuesForm, positionName: newValue})
                                // setUserLeader(newValue)
                            
                            }}
                            renderOption={(props, option) => (
                            <Box component="li" {...props}>
                                    {option?.name}
                            </Box>
                            )}
                            value={valuesForm?.positionName}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                disabled={!organization?.leaderId}
                                {...register('positionName')}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                placeholder="cargo"
                                label="cargo"
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                }}
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item lg={2.5}>
                    <FormControl variant='outlined' fullWidth size="small">
                        <TextField
                            {...register('idKeyword')}
                            label="Identificación"
                            className={classes.dropdown}
                            size="small"
                            disabled={!organization?.leaderId}
                            inputProps={{
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            placeholder="Identificación"
                            error={!!errors.hasOwnProperty("idKeyword") && errors["idKeyword"].message}
                        />
                    </FormControl>
                    <FormHelperText style={{color:'#d32f2f', marginLeft: '2%'}}>
                        {errors.hasOwnProperty("idKeyword") &&
                            errors["idKeyword"].message}
                    </FormHelperText> 
                </Grid>
                <Grid item lg={2.5}>
                    <FormControl variant='outlined' fullWidth size="small">
                        <TextField
                            {...register('nameKeyword')}
                            label="Nombre"
                            className={classes.dropdown}
                            size="small"
                            disabled={!organization?.leaderId}
                            inputProps={{
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                            placeholder="Nombre"
                            error={!!errors.hasOwnProperty("nameKeyword") && errors["nameKeyword"].message}
                        />
                    </FormControl>
                    <FormHelperText style={{color:'#d32f2f', marginLeft: '2%'}}>
                        {errors.hasOwnProperty("nameKeyword") &&
                            errors["nameKeyword"].message}
                    </FormHelperText> 
                </Grid>           
                <Grid item xs={12} sm={12} md={12} lg={2} className={classes.buttons}>
                    <Button 
                        variant="contained" 
                        type="submit" 
                        disableElevation 
                        disabled={!validate || !organization?.leaderId}
                        color="primary"
                    >
                        BUSCAR
                    </Button>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; 
                    <Button 
                        variant="outlined" 
                        onClick={clearForm} 
                        disableElevation 
                        style={{background: "#ffffff"}}
                    >
                        Limpiar
                    </Button>

                </Grid>
            </Grid>
        
        </form>
    )
}

export default SearchUsers
